import React, {useState} from "react";
import '../components/styles.css'
import { Link, useNavigate } from "react-router-dom";
import setCookie from "../setCookie";
import { ColorRing } from "react-loader-spinner";

 
export default function Login(){
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [loading, setLoading] = useState(false); 
    const navigate = useNavigate();
    const loginUser = async(event) => {
            event.preventDefault();
            setLoading(true)
            document.getElementById('login').disabled = true;
            try {
                const baseURL = process.env.REACT_APP_BASEURL;
                const url  = baseURL + "login";
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({email, password}),
                });
                
                if (response.ok) {
                    const data = await response.json();
                    setCookie("auth-cookie", data.token);
                    
                    setTimeout(() => {
                        setLoading(false);
                        navigate("/dashboard");}, 2000);
                } else {
                    const data = await response.json();
                    alert(data.detail);       // Display any error message from the backend
                    setLoading(false);
                    document.getElementById('login').disabled = false;
                }
            } catch (error) {
                
                alert(error.message);
                document.getElementById('login').disabled = false;
                
            }
     }
    

    return(
        <div className = "form-container">
           <form id= "login-form" className = "form-card">
                <p className="form-header">Login</p>
                <input className = "form-input" onChange = {(e) => setEmail(e.target.value)} type="email" placeholder="Enter your email address" required></input>
                <input className = "form-input" onChange = {(e) => setPassword(e.target.value)} type="password" placeholder="Enter a password" required></input>
                <button id='login' onClick = {loginUser} className = "form-submit-button">Login</button>
                {loading && (
                                <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={[
                                    "#e15b64",
                                    "#f47e60",
                                    "#f8b26a",
                                    "#abbd81",
                                    "#849b87",
                                    ]}
                                />
                    )}
                
                <div className ='form-redirect-section'>
                    <Link className="formLink" to = "/forgotpassword">Forgot Password</Link>
                </div>
                <div className ='form-redirect-section'>
                    <p className="para-text">Not a member yet?</p>
                    <Link className="formLink" to = "/signup">Signup</Link>
                </div>
                
                
           </form>
        </div>
        
    )
    
   }